import { IBin, IGroupMembershipsMetrics } from '@sparelabs/api-client'
import { IListModelQueryParamValues } from '@sparelabs/http-client-utils'

export enum EngageMetricType {
  Cases = 'cases',
  Assignment = 'assignment',
  GroupMemberships = 'groupMemberships',
}

export type EngageMetricOutputType = ICasesMetrics | IAssignmentMetrics | IGroupMembershipsMetrics

interface IEngageMetricOutput<T extends EngageMetricType, D extends EngageMetricOutputType> {
  type: T
  data: D
}

export type IEngageMetric =
  | IEngageMetricOutput<EngageMetricType.Cases, ICasesMetrics>
  | IEngageMetricOutput<EngageMetricType.Assignment, IAssignmentMetrics>
  | IEngageMetricOutput<EngageMetricType.GroupMemberships, IGroupMembershipsMetrics>

export interface IEngageMetricsResponse {
  metrics: IEngageMetric[]
}

export interface IListEngageMetricsQueryParams extends IListModelQueryParamValues {
  metricTypes: EngageMetricType[]
  fromTs: number
  toTs: number
  caseTypeIds?: string[]
  adminIds?: string[]
  groupIds?: string[]
}

export interface ICasesMetrics {
  totalCreatedCases: number
  totalActiveCases: number
  totalArchivedCases: number

  totalInProgressCases: number
  totalDoneCases: number

  totalStatusCases: Record<string, number>

  totalCreatedCasesBins: IBin[]
}

export interface IAssignmentMetrics {
  totalAssignedCases: number
  totalUnassignedCases: number

  totalAssignedCasesBins: IBin[]
}
